import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import NoticeBlue from '@/pages/aigc/pages/Agent/svg/notice-blue.svg';
import Notice from '@/pages/aigc/pages/Agent/svg/notice-yellow.svg';
import classNames from 'classnames';
// 权限提示区域
export const AccessCmp = (props: any) => {
  const { value } = props;
  const { formatMessage, locale } = useIntl();

  const { accessContent, isSensitive } = useMemo(() => {
    let content: React.ReactNode = null;
    let sensitive = true;
    
    // 检查是否有管理看板权限
    const hasMgmtAccess = value?.mgmt_retrieved_data === true;
    
    // 提取游戏列表
    const formatGames = (games: string[]) => (
      <span style={{ fontWeight: '600' }}>{games.join('、')}</span>
    );
    
    // 根据不同类型生成不同文案
    switch (value.type) {
      case 'none':
        if (hasMgmtAccess) {
          // intelligence_1 或 dashboard_1 且有管理看板权限的特殊文案
          sensitive = true;
          content = (
            <span>
              {formatMessage({ id: 'dba_access_mgmt_intelligence_prefix' })}
              {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}
              {formatMessage({ id: 'dba_access_mgmt_intelligence_suffix' })}
              {formatMessage({ id: 'dba_access_mgmt_dashboard' })}
              {formatMessage({ id: 'dba_access_mgmt_intelligence_end' })}
            </span>
          );
        };
        break;
        
      case 'intelligence_1':
      case 'dashboard_1':
        if (hasMgmtAccess) {
          // intelligence_1 或 dashboard_1 且有管理看板权限的特殊文案
          sensitive = true;
          content = (
            <span>
              {formatMessage({ id: 'dba_access_mgmt_intelligence_prefix' })}
              {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}
              {formatMessage({ id: 'dba_access_mgmt_intelligence_suffix' })}
              {formatMessage({ id: 'dba_access_mgmt_dashboard' })}
              {formatMessage({ id: 'dba_access_mgmt_intelligence_end' })}
            </span>
          );
        } else {
          // dashboard_1 或 intelligence_1 无管理权限的逻辑
          sensitive = false;
          content = <span>{formatMessage({ id: 'dba_access_nodash' })}</span>;
        }
        break;

      case 'dashboard_2':
        sensitive = false;
        if (!value.black_games || value.black_games.length === 0) {
          // 当black_games为空时，使用dashboard_1的格式
          content = <span>{formatMessage({ id: 'dba_access_nodash' })}</span>;
        } else {
          // 正常dashboard_2的格式
          content = (
            <span>
              {formatMessage({ id: 'dba_access_dash2_left' })}
              {formatGames(value.black_games)}
              {formatMessage({ id: 'dba_access_dash2_right' })}
            </span>
          );
        }
        break;

      case 'dashboard_3':
        if (!value.black_games || value.black_games.length === 0) {
          // 当black_games为空时，使用dashboard_4的格式
          content = (
            <span>
              {hasMgmtAccess ? (
                <>
                  {formatMessage({ id: 'dba_access_dash3_left' })}
                  {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}
                  {formatMessage({ id: 'dba_access_mgmt_permission_comma' })}
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_right' })}
                  {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}、
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_end' })}
                </>
              ) : (
                <>
                  {formatMessage({ id: 'dba_access_dash3_left' })}
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_right' })}
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_end' })}
                </>
              )}
            </span>
          );
        } else {
          // 正常dashboard_3的格式
          content = (
            <span>
              {hasMgmtAccess ? (
                <>
                  {formatMessage({ id: 'dba_access_dash3_left' })}
                  {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}
                  {formatMessage({ id: 'dba_access_mgmt_permission_comma' })}
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_mid' })}
                  {formatGames(value.black_games)}
                  {formatMessage({ id: 'dba_access_dash3_right' })}
                  {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}、
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_end' })}
                </>
              ) : (
                <>
                  {formatMessage({ id: 'dba_access_dash3_left' })}
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_mid' })}
                  {formatGames(value.black_games)}
                  {formatMessage({ id: 'dba_access_dash3_right' })}
                  {formatGames(value.white_games)}
                  {formatMessage({ id: 'dba_access_dash3_end' })}
                </>
              )}
            </span>
          );
        }
        break;

      case 'dashboard_4':
        content = (
          <span>
            {hasMgmtAccess ? (
              <>
                {formatMessage({ id: 'dba_access_dash3_left' })}
                {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}
                {formatMessage({ id: 'dba_access_mgmt_permission_and' })}
                {formatGames(value.white_games)}
                {formatMessage({ id: 'dba_access_dash3_right' })}
                {formatGames([formatMessage({ id: 'dba_access_mgmt_dashboard' })])}
                {formatMessage({ id: 'dba_access_mgmt_permission_and' })}
                {formatGames(value.white_games)}
                {formatMessage({ id: 'dba_access_dash3_end' })}
              </>
            ) : (
              <>
                {formatMessage({ id: 'dba_access_dash3_left' })}
                {formatGames(value.white_games)}
                {formatMessage({ id: 'dba_access_dash3_right' })}
                {formatGames(value.white_games)}
                {formatMessage({ id: 'dba_access_dash3_end' })}
              </>
            )}
          </span>
        );
        break;

      default:
        content = null;
    }
    return { accessContent: content, isSensitive: sensitive };
  }, [locale, value]);

  if (!value || typeof value !== 'object' || !value.type) {
    return null;
  }
  return (
    <div
      className={classNames(
        'dba-access-container',
        !isSensitive && 'dba-access-blue',
      )}
    >
      {isSensitive && (
        <div className="dba-access-title">
          <img src={Notice} alt="" />
          <span>{formatMessage({ id: 'dba_access_title' })}</span>
        </div>
      )}
      <div className="dba-access-box">
        {!isSensitive && (
          <div className="dba-access-icon">
            <div className="dba-access-icon-box">
              <img src={NoticeBlue} alt="" />
            </div>
          </div>
        )}
        <span
          className={classNames(
            'dba-acess-text',
          )}
        >
          {accessContent}
        </span>
      </div>
    </div>
  );
};
